<grid-row class="mt-20">
    <grid-col col="6">
        <ng-icon iconClass="icon-nav-home" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-nav-loan" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-nav-apply" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-nav-setting" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-nav-location" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-nav-contact" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-location" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-nav-logout" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-nav-card" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-gift-box" width="24" height="24"></ng-icon>

        <ng-icon iconClass="icon-card-transfer" width="48" height="48"></ng-icon>
        <ng-icon iconClass="icon-otp-pin" width="48" height="48"></ng-icon> 

        <ng-icon iconClass="icon-change-card" width="72" height="72"></ng-icon> 
        <ng-icon iconClass="icon-email-black-big" width="72" height="72"></ng-icon> 


        <ng-icon iconClass="icon-card-freeze" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-card-pin" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-card-nick-name" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-card-statement" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-card-stop" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-contact" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-quick-pay" width="26" height="26"></ng-icon>

        <ng-icon iconClass="icon-info" width="26" height="26"></ng-icon>

        <ng-icon iconClass="icon-heart-black" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-heart-active" width="18" height="25"></ng-icon>
        <ng-icon iconClass="icon-heart-white" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-brightness-verify" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-display-verify" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-format-verify" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-close" width="26" height="26"></ng-icon>
        <ng-icon iconClass="icon-mobile-black" width="28" height="28"></ng-icon>

        <ng-icon iconClass="icon-upload" width="18" height="18"></ng-icon>
        <ng-icon iconClass="icon-delete" width="18" height="18"></ng-icon>

        <ng-icon iconClass="icon-arrow-left-blue" width="24" height="24"></ng-icon> 
        <ng-icon iconClass="icon-mobile-blue" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-signup" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-arrow-left-white" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-arrow-left-sky-blue" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-eye-open" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-transport" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-travel" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-food" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-gadgets" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-health" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-retails" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-fitness" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-others" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-outlet" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-replace-card" width="24" height="24"></ng-icon> 
        <ng-icon iconClass="icon-email-blue-sm" width="24" height="24"></ng-icon> 
        <ng-icon iconClass="icon-physical-card" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-email-black-sm" width="40" height="40"></ng-icon>

        <ng-icon iconClass="icon-setting-email" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-setting-mobile" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-setting-change-pin" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-setting-arrow-right" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-manage-pin" width="24" height="24"></ng-icon>



        <ng-icon iconClass="icon-remove-modal" width="72" height="72"></ng-icon>
        <ng-icon iconClass="icon-mobile-otp" width="72" height="72"></ng-icon>
        <ng-icon iconClass="icon-freeze-white" width="72" height="72"></ng-icon>
        <ng-icon iconClass="icon-freeze-black" width="75" height="75"></ng-icon>
        <ng-icon iconClass="icon-stop-card" width="80" height="80"></ng-icon>
        <ng-icon iconClass="icon-re-issue-pin" width="72" height="72"></ng-icon>
        <ng-icon iconClass="icon-success-black" width="72" height="72"></ng-icon>
        <ng-icon iconClass="icon-suspend" width="72" height="72"></ng-icon>
        <ng-icon iconClass="icon-suspend-black" width="72" height="72"></ng-icon>
        <ng-icon iconClass="icon-logout-black-big" width="72" height="72"></ng-icon>

        <ng-icon iconClass="icon-logo" width="108" height="108"></ng-icon>
        <ng-icon iconClass="icon-logo-mini" width="56" height="56"></ng-icon>

        <!-- active nav -->
        <ng-icon iconClass="icon-credit-card" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-loan" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-home" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-card-car" width="30" height="30"></ng-icon>

        <!--tooltip-icon have White icon -->
        <ng-icon iconClass="icon-tooltip-success" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-tooltip-close" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-contactless" width="19" height="24"></ng-icon>
        <ng-icon iconClass="icon-profile" width="56" height="64"></ng-icon>

        <ng-icon iconClass="icon-insure-1" width="85" height="115"></ng-icon>
        <ng-icon iconClass="icon-inssure-2" width="165" height="115"></ng-icon>
        <ng-icon iconClass="icon-insure-3" width="140" height="115"></ng-icon>

        <ng-icon iconClass="icon-creditcard-not-available" width="307" height="230"></ng-icon>
        <ng-icon iconClass="icon-loan-dashboard-big" width="120" height="120"></ng-icon>

        <ng-icon iconClass="icon-Imtiaz-for-her" width="96" height="25"></ng-icon>
        <ng-icon iconClass="icon-download" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-arrow-left-black" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-MasterCard" width="40" height="25"></ng-icon> 
        <ng-icon iconClass="icon-vehicle-loan" width="58" height="64"></ng-icon> 
        <ng-icon iconClass="icon-youtube" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-instagram" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-facebook" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-linkdin" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-imtiaz-mastercard" width="126" height="78"></ng-icon>
        <ng-icon iconClass="icon-imtiaz-lock" width="73" height="103"></ng-icon> 
        <ng-icon iconClass="icon-imtiaz-header" width="90" height="72"></ng-icon> 
        <ng-icon iconClass="icon-imtiaz-lock-bg" width="250" height="103"></ng-icon> 

<!-- NEW ICONS ADDED By SHAHRIYAR -->
        <ng-icon iconClass="icon-nav-login" width="29" height="29"></ng-icon>
        <ng-icon iconClass="icon-email-us" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-BCFC-branches" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-skip-queue" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-phone-call" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-feedback-complaints" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-rate-us" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-linkd-In" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-facebook" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-insta" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-you-tube" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-quick-pay-gray" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-explore" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-card-girl" width="130" height="96"></ng-icon>  
        <ng-icon iconClass="icon-credit-card-green" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-laon-green" width="29" height="29"></ng-icon> 
        <ng-icon iconClass="icon-success-100px" width="100" height="100"></ng-icon> 
        <ng-icon iconClass="icon-info-big" width="56" height="56"></ng-icon> 
        <ng-icon iconClass="icon-benifit" width="32" height="32"></ng-icon> 
        <ng-icon iconClass="icon-getway" width="32" height="32"></ng-icon> 
        <ng-icon iconClass="icon-card-enjoy" width="130" height="96"></ng-icon>
        <ng-icon iconClass="icon-mobile-otp-new" width="56" height="56"></ng-icon>
        <ng-icon iconClass="icon-elite-insurance" width="141" height="113"></ng-icon>
        <ng-icon iconClass="icon-sahel-logo-trans" width="128" height="40"></ng-icon>
        <ng-icon iconClass="icon-linkd-In-green bg-base-100 br-100" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-facebook-green bg-base-100 br-100" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-insta-green bg-base-100 br-100" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-you-tube-green bg-base-100 br-100" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-info-green-big" width="100" height="100"></ng-icon>
        <ng-icon iconClass="icon-pay-card-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-freez-card-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-manage-pin-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-nickname-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-card-statement-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-stop-card-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-more-action-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-replace-card-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-manage-card-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-service-latter-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-manage-spending-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-request-supplementary-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-cancel-card-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-review-success" width="100" height="100"></ng-icon>
        <ng-icon iconClass="icon-verify-yourself" width="75" height="62"></ng-icon>
        <ng-icon iconClass="icon-check-custom" width="75" height="62"></ng-icon>
        <ng-icon iconClass="icon-pay-loan-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-defer-instalment-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-email-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-mobile-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-loaction-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-bell-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-fingerprint-green" width="26" height="27"></ng-icon>
        <ng-icon iconClass="icon-edit-green" width="20" height="20"></ng-icon>
        <ng-icon iconClass="icon-delete-16px" width="20" height="20"></ng-icon>
        <ng-icon iconClass="icon-remove-address" width="20" height="20"></ng-icon>
        <ng-icon iconClass="icon-redeem-small" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-filter-transaction" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-close-10px" width="10" height="10"></ng-icon>
        <ng-icon iconClass="icon-cash-back" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-gulf-air" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-shukran" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-like-32px" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-filter-big" width="32" height="32"></ng-icon>
        <ng-icon iconClass="icon-all-deal" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-all-deal-active" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-food-tab" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-outlet-tab" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-outlet-tab-active" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-gadgets-tab" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-health-tab" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-supermarket-tab" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-groceries-tab" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-entertainment-tab" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-others-tab" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-facbook-black" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-insta-black" width="16" height="16"></ng-icon>
        <ng-icon iconClass="icon-verify-account" width="72" height="72"></ng-icon>
        <ng-icon iconClass="icon-pagination-right-active" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-pagination-left" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-heart-active" width="24" height="24"></ng-icon>
        <ng-icon iconClass="icon-download-new" width="24" height="24"></ng-icon>



    </grid-col>
    <grid-col col="6">
        <grid-row class="justify-content-center">
            <grid-col col="6">
                <div class="mt-15">
                    <button class="btn-dft">
                        {{ "primary button" | translate }}
                    </button>
                </div>
                <div class="mt-15">
                    <button class="btn-dft-border">
                        {{ "Secondary button" | translate }}
                    </button>
                </div>
                <div class="mt-15">
                    <button class="btn-back" (click)="back()">
                        <i class="icon-back"></i>
                    </button>
                </div>
                <grid-row class="mt-50">
                    <grid-col col="3">
                        <button class="btn-dft" [routerLink]="['/CreateAppPin']">
                            {{ "VERIFY" | translate }}
                        </button>
                        <div class="form-group mt-30">
                            <div class="custom-toggle">
                                <input type="checkbox" id="toggle1" class="not-on-this" [(ngModel)]="tinNumber">
                                <label for="toggle1" class="not-on-this"></label>
                            </div>
                        </div>
                    </grid-col>
                </grid-row>
            </grid-col>
        </grid-row>
    </grid-col>
</grid-row>